import React from "react";
import PageTitle from "../../../components/PageTitle";
import TableWithAddForm from "../../../../../components/TableWithAddForm";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { engineer, isEngineerLoading } from "../../../selectors/engineers";
import {
  engineerPageLoad,
  engineerUpdateRequest,
  engineerEmailAddRequest,
  engineerEmailDeleteRequest,
} from "../../../actions/engineers";
import { push } from "react-router-redux";
import EngineerForm from "../../../components/forms/Engineer";
import { regionsAvailableToEngineers } from "../../../selectors/regions";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";

export default props =>
  isNaN(props.match.params.id) ? (
    <PageNotFound />
  ) : (
    <EditEngineerPage engineerId={parseInt(props.match.params.id, 10)} />
  );

const EditEngineerPage = connect(
  (state, ownProps) => ({
    engineer: engineer(state),
    regions: regionsAvailableToEngineers(state),
    loading: isEngineerLoading(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(engineerPageLoad(ownProps.engineerId)),
    onSave: formData =>
      dispatch(engineerUpdateRequest(ownProps.engineerId, formData)),
    onAddEmail: email =>
      dispatch(engineerEmailAddRequest(ownProps.engineerId, email)),
    onDeleteEmail: email =>
      dispatch(engineerEmailDeleteRequest(ownProps.engineerId, email)),
    onEngineerList: () => dispatch(push("/engineers")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading..." />;
    }

    return (
      <div id="edit-engineer-page">
        <PageTitle title="Edit Engineer" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onEngineerList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to engineers list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Engineer data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <EngineerForm
                  engineer={props.engineer}
                  regions={props.regions}
                  onSave={props.onSave}
                  disabled={props.engineer.generalDataSaveInProgress}
                  backendError={props.engineer.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              Engineer email addresses
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <TableWithAddForm
                  title="Email"
                  email
                  helpText="Enter the contact email addresses that are common to this Engineer. These will appear in the contact info for any Engineers associated with this Engineer."
                  disabled={props.engineer.emailAddInProgress}
                  backendError={props.engineer.emailAddError}
                  data={props.engineer.emails}
                  onAdd={props.onAddEmail}
                  onDelete={props.onDeleteEmail}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/engineers/Edit.js